import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const ViewMoreCTA = ({ onClick, label = 'View more' }) => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'primary.main',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backgroundColor: 'info.dark',
        ':hover': {
          backgroundColor: 'info.main',
        },
        borderRadius: 1,
        minHeight: '200px',
        maxWidth: '200px',
        width: '200px',
      }}
      onClick={onClick}
    >
      <Typography color="primary" variant="body1" sx={{ fontWeight: 'medium' }}>
        {label}
      </Typography>
    </Box>
  );
};

ViewMoreCTA.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default ViewMoreCTA;
